import React, { useContext } from 'react';

// import i18n from '../../i18n';
// import PropTypes from 'prop-types';
import s from './ButtonPrimaryEllipse.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import { GradientContext } from '../../containers/BasePage';

const ButtonPrimaryEllipse = ({
    asLink = false,
    active,
    children,
    disabled,
    size,
    icon = 'icon-arrow-right-white',
    iconDimensions = [20, 20],
    hideText = false,
    onColor = 'black' /* if the button is on a white component this is white */,
    modifiers = [],
    onClick,
    hideStroke = false,
    fromPage,
    isHovered = false,
    animateIcon = true,
    ...props
}) => {
    const gradient = useContext(GradientContext);

    const rootClasses = classNames(
        s.Root,
        {
            [s.Active]: !!active,
            [s.Disabled]: !!disabled,
            [s.Small]: size === 'small',
            [s.OnWhite]: onColor !== 'black',
            [s.Play]: icon === 'icon-play',
            [s.Hover]: isHovered,
            [s.AnimateIcon]: animateIcon,
        },
        s[gradient],
        s[fromPage],
        modifiers.map((m) => s[m])
    );

    const [iconWidth, iconHeight] = iconDimensions;

    return asLink ? (
        <Link {...props} onClick={onClick} className={rootClasses}>
            {icon && (
                <span className={s.IconWrap}>
                    <span className={s.IconInner}>
                        <Image
                            width={22}
                            height={22}
                            src={`/img/${icon}.svg`}
                            alt=""
                            className={classNames(s.Icon, s.IconDefault)}
                        />
                        <Image
                            width={22}
                            height={22}
                            src={`/img/${icon}.svg`}
                            alt=""
                            className={classNames(s.Icon, s.IconHover)}
                        />
                    </span>
                    {!hideStroke && <i className={s.Bg} aria-hidden={true} />}
                </span>
            )}
            {hideText ? <span className="sr-only">{children}</span> : <span className={s.Text}>{children}</span>}
        </Link>
    ) : (
        <button type="button" onClick={onClick} disabled={disabled} className={rootClasses} {...props}>
            {icon && (
                <span className={s.IconWrap}>
                    <span className={s.IconInner}>
                        <Image
                            width={22}
                            height={22}
                            src={`/img/${icon}.svg`}
                            alt=""
                            className={classNames(s.Icon, s.IconDefault)}
                        />
                        <Image
                            width={22}
                            height={22}
                            src={`/img/${icon}.svg`}
                            alt=""
                            className={classNames(s.Icon, s.IconHover)}
                        />
                    </span>
                    {!hideStroke && <i className={s.Bg} aria-hidden={true} />}
                </span>
            )}
            {children &&
                (hideText ? <span className="sr-only">{children}</span> : <span className={s.Text}>{children}</span>)}
        </button>
    );
};

ButtonPrimaryEllipse.propTypes = {};

ButtonPrimaryEllipse.defaultProps = {};

export default ButtonPrimaryEllipse;
